import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';
import type { JSX } from 'react';

interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  cover: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  views: number;
  tags: string[];
}

export default function ArticleSection(): JSX.Element {
  const recent = getRecentArticles(4);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
              直播资讯
            </h2>
            <p className="text-foreground-600 text-base">最新的直播行业动态和观看指南</p>
          </div>
          <Link
            to="/articles"
            className="flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {recent.map((article: Article) => (
            <Link
              key={article.id}
              to={`/articles/${article.id}`}
              className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-48 h-36 shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-foreground-400 text-xs">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-[10px]"></i>
                    {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}